import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ToastContainer from './components/ui/helpers/ToastContainer';
import { RouteApp } from './routes/Routes';
import { AuthProvider } from '@auth';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastContainer />
        <RouteApp />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;